module.exports = "pegasus/assets/preview-22.png";